import React from "react";
import { LineChart } from "react-chartkick";
import Chart from "chart.js";

Chart.defaults.global.defaultFontColor = "#FFFA";
function Graph(props) {
  return (
    <div style={{
      alignSelf: 'center'
    }}>
    <LineChart {...props} discrete={true} min={null} width={"100%"} />
      </div>
  );
}

export { Graph };
